/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Queue_Availability_MismatchesInputs */

const en_queue_availability_mismatches = /** @type {(inputs: Queue_Availability_MismatchesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Availability mismatches to check`)
};

/**
* | output |
* | --- |
* | "Availability mismatches to check" |
*
* @param {Queue_Availability_MismatchesInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const queue_availability_mismatches = /** @type {((inputs?: Queue_Availability_MismatchesInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Queue_Availability_MismatchesInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_queue_availability_mismatches(inputs)
});